import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const HeroAlt = (props) => {
  return (
    <Container fluid className="hero-alt" as="section">
      <Container>
        <Row>
          <Col>
            <h1 data-aos="fade-right">{props.title}</h1>
            <p data-aos="fade-left">{props.pageDescription}</p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
